import React, { ChangeEvent, CSSProperties } from 'react'

/**
 * Компонент для загрузки файлов
 * Рендерит скрытый инпут и кнопку для выбора файла
 */
class FileInput extends React.Component<Props> {
  private ref = React.createRef<HTMLInputElement>()

  componentDidMount() {
    if (this.props.autofocus) this.handleClick()
  }

  private handleClick = () => {
    !this.props.disabled && this.ref.current.click()
  }

  private handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files.length === 0) return
    const files = Array.from(e.target.files as FileList).slice(0, this.props.maxFiles ?? 1)
    const firstFile = files[0]
    if (!firstFile) return

    const reader = new FileReader()
    reader.readAsText(firstFile)

    reader.onload = () => {
      this.props.onChange(reader.result as string, firstFile)
      this.props.onFilesChange?.(files)
    }

    e.target.value = ''
  }

  render() {
    return (
      <React.Fragment>
        <button
          style={{ width: 'fit-content' }}
          className='etba-button'
          onClick={this.props.onClick ?? this.handleClick}
          data-theme={this.props.buttonClass || 'primary'}
        >
          <span>{this.props.children}</span>
        </button>
        <input
          style={{ display: 'none' }}
          ref={this.ref}
          className='etba-input'
          type='file'
          accept={this.props.accept}
          multiple={this.props.multiple}
          onChange={this.handleChange}
        />
      </React.Fragment>
    )
  }
}

interface Props {
  accept?: string // какие расширения файлов принимать
  onChange: (content: string, file: File) => void
  onFilesChange?: (files: File[]) => void
  children: React.ReactNode | React.ReactNodeArray
  buttonClass?: 'primary' | 'grey-outline' | 'secondary'
  style?: CSSProperties
  autofocus?: boolean
  disabled?: boolean
  onClick?: () => void
  multiple?: boolean // для выбора нескольких файлов
  maxFiles?: number // если не передано, то 1
}

export default FileInput
